import React from 'react';
import { Col, Collapse } from 'reactstrap';
import format from 'date-fns/format';
import { useSelector } from '../../redux';
import {
  WhitePanelLayout,
  Prices,
  PaymentSummarySpan,
  Promocode,
} from '@dom/components';

import { useToggle } from '../../hooks';
import { getLocaleString } from '../../utils';
import { GUIDE_INSURANCE_COST } from '../../constants';
import { getGuideDataById, getGuideSearchQuery } from '../../redux/selectors';
import { usePromocode } from '@dom/components';

const formatter = date => format(date, 'MMMM D, YYYY');

export default function GuidePaymentSummary(props) {
  const { on, toggle } = useToggle();
  const {
    lineItem: {
      itemData: {
        startDate,
        endDate,
        numTrekkers: pax,
        dailyWages: { amount: guideWage },
        numberOfDays,
      },
    },
    invoice,
    guideId,
  } = props;

  let { amount, discount, rate, currency = 'USD' } = invoice;

  const { name } = useSelector(getGuideDataById(guideId)) || {};
  const { guideQuery: trekName } = useSelector(getGuideSearchQuery) || {};

  const checkinDate = formatter(startDate);
  const checkoutDate = formatter(endDate);
  const guideCost = Number(guideWage) * Number(numberOfDays);

  const dailyWageWithCurrency = `${currency} ${guideWage} Per Day`;
  
  const [promocodeResponse] = usePromocode();

  if (promocodeResponse) { 
    const { promocodeAmount, purchaseAmount, totalAmount } = promocodeResponse;

    rate = purchaseAmount;
    discount = promocodeAmount; 
    amount = totalAmount; 
  }

  return (
    <Col lg="6" xs="12">
      <WhitePanelLayout title="SUMMARY" className="summary">
        <h3 className="date">
          {checkinDate} - {checkoutDate}
        </h3>
        <h3 className="name">{name}</h3>
        <ul className="detail">
          <PaymentSummarySpan title="Trek Name" value={trekName} />
          <PaymentSummarySpan title="No. of people" value={pax} />
          <PaymentSummarySpan title="No. of days" value={numberOfDays} />
          <PaymentSummarySpan
            title="Daily Wage"
            value={dailyWageWithCurrency}
          />
        </ul>

        <hr />

        <button onClick={toggle}>View all price breakdown</button>
        <Collapse isOpen={on}>
          <ul className="price-breakdown">
            <PaymentSummarySpan
              title="Guide total cost"
              value={`(${currency} ${guideWage}/Day x ${numberOfDays} Days)
              ${currency} ${getLocaleString(guideCost)}`}
            />
            <PaymentSummarySpan
              title="Guide Insurance"
              value={`${currency} ${GUIDE_INSURANCE_COST}`}
            />
          </ul>
        </Collapse>
        <hr />

        <Prices
          currency={currency}
          basePrice={rate}
          discount={discount}
          grandTotal={amount}
        />
        <Promocode invoiceId={invoice.id} />
      </WhitePanelLayout>
    </Col>
  );
}
